<mat-form-field>
  <mat-chip-list #chipList>
    <ng-container *ngIf="hasTooltip; then chipWithTooltip; else chipWithoutTooltip"></ng-container>
    <ng-template #chipWithTooltip>
      <mat-chip
        *ngFor="let record of records"
        [selectable]="selectable"
        [removable]="removable"
        [disabled]="readonly"
        [matTooltip]="(pathToTooltip + record.name) | translate"
        (removed)="remove(record)">
        <img class="avatar" *ngIf="hasAvatar" src="{{record?.img}}">
        {{ display(record) }}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      </mat-chip>
    </ng-template>
    <ng-template #chipWithoutTooltip>
      <mat-chip
        *ngFor="let record of records"
        [selectable]="selectable"
        [removable]="removable"
        (removed)="remove(record)">
        <img class="avatar" *ngIf="hasAvatar" src="{{record?.img}}">
        {{ display(record) }}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      </mat-chip>
    </ng-template>
    <input
      #chipsInput
      [placeholder]="label"
      [formControl]="recordControl"
      [readOnly]="readonly"
      [required]="required ? '' : null"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="add()">
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let record of filteredRecords | async" [value]="record">
      {{ display(record) }}
    </mat-option>
  </mat-autocomplete>
  <mat-icon *ngIf="!isDisabled" matSuffix (click)="add()">add</mat-icon>
</mat-form-field>
<app-form-error-list
        *ngIf="showErrors"
        [errorMap]="formControl.errors">
</app-form-error-list>
